import React, { Fragment } from 'react';
import PreOEPLanding from './pre-oep_landing';
import { bindActionCreators, Dispatch } from 'redux';
import { getEnvironment } from '@actions/common/actionCreators';
import { connect } from 'react-redux';

interface IEnvironment {
    exchangeName: string;
    links: {
        PHONE: string;
    };
}

interface IStateProps {
    environment: IEnvironment;
}

interface IDispatchProps {
    actions: {
        getEnvironment: () => void;
    };
}

type IProps = IStateProps & IDispatchProps;

const PreOEPLandingContainer = (props: IProps) => {
    const {
        environment: {
            exchangeName,
            links: {
                PHONE: phone
            },
        }
    } = props;

    return (
        <Fragment>
            <main className="usa-layout-docs usa-section gi-main-section" id="keystone__page">
                <div className="grid-container gi-grid-container">
                    <div className="grid-row grid-gap gi-wrapper">
                        <div className="grid-col-12">
                            <div className="grid-row">
                                <div className="desktop:grid-col-12" id="main-content">
                                    <PreOEPLanding {...{ exchangeName, phone }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};

const mapStateToProps = (state: any): IStateProps => ({
    environment: state.common.environment,
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    actions: bindActionCreators({
        getEnvironment
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PreOEPLandingContainer);
